export const predefinedTextState = {
    errorCode : 0,
    statusCode : 0,
    predefinedTextList : [],
    message : '',
    regionList:[],
    isLoading : false
}
